import type { Inventory, ResourceKind } from "./types";
export const RESOURCES: Record<
  ResourceKind,
  {
    name: string;
    health: number;
    respawn: number;
    rewards: Partial<Inventory>;
    note: string;
  }
> = {
  tree: {
    name: "林木",
    health: 72,
    respawn: 40,
    rewards: { wood: 4, islandDust: 1 },
    note: "木材 ×4 · 芭蕉擅长",
  },
  rock: {
    name: "青晶岩",
    health: 92,
    respawn: 45,
    rewards: { stone: 4, islandDust: 1 },
    note: "石料 ×4 · 冬瓜擅长",
  },
  berry: {
    name: "蜜莓丛",
    health: 35,
    respawn: 55,
    rewards: { food: 3 },
    note: "食物 ×3 · 胡萝卜擅长",
  },
  herb: {
    name: "清露药草",
    health: 40,
    respawn: 65,
    rewards: { fertilizer: 2, water: 2 },
    note: "肥料 ×2、水 ×2",
  },
  amber: {
    name: "琥珀灵矿",
    health: 140,
    respawn: 100,
    rewards: { stone: 2, spiritDew: 1, islandDust: 2 },
    note: "灵露 ×1、石料 ×2、浮土 ×2",
  },
};
